export const SET_LOADING = 'SET_LOADING'
export const SET_RUBROS = 'SET_RUBROS'

export const url = '/apirubro_planes/'